import type { ProctorSpecification } from "./ProctorSpecification";
import type { ProctorAllocation } from "../native-modules/types/JSTProctorBridge";

export type BucketFields<Specification extends ProctorSpecification> = {
  [K in keyof Specification["buckets"] as `is${K & string}`]: boolean;
};

export type ProctorBucketAllocation<Specification extends ProctorSpecification> = {
  value: number;
  payloadJson: string | null;
} & {
  [K in keyof Specification["buckets"] as `is${K & string}`]: boolean;
};

export function buildProctorBucketAllocation<Specification extends ProctorSpecification>(
  spec: Specification,
  result: ProctorAllocation | undefined,
): ProctorBucketAllocation<Specification> {
  // it is possible that the proctor tare bridge was not available on old devices
  const { value, payload: payloadJson } = result ?? { value: -1, payload: null };
  const fields = Object.fromEntries(
    Object.entries(spec.buckets).map(([k, v]) => [`is${k}`, value === v]),
  ) as BucketFields<Specification>;
  return { value, payloadJson, ...fields };
}
